import { AdminRole, MerchantRole } from 'src/app/shared/enums/roles';

export interface IAuth {
  _id: string;
  accessToken: string | null;
  refreshToken: string | null;
  email: string;
  roles: AdminRole | MerchantRole;
  isFirstTime: boolean;
  canAccessFreeOrganizer?: boolean;
  hasOrganizerMerchant?: boolean;
  displayName?: string;
  pictureUrl?: string;
  lineConnected?: boolean;
  lineDisplayName?: string;
  authSource?: 'LINE' | 'PASSWORD';
}

export interface IAuthFeatureState {
  user: IAuth | null;
  authenticationGeneration: number;
  isProfileInitializing: boolean;
  isLoading: boolean;
  error: string | null;
  isAuthenticate: boolean;
  isSuccess: boolean;
  isLineLoading: boolean;
  lineError: string | null;
}

export const authFeatureKey = 'auth';
